// Global Instructions Rule Applied!
import { fetchFundraisingFiltered } from '../services/fundraisingService.ts'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFundraising } from '../../../state_manager/state_update_actions/fundraising/index.ts'
import { FundraisingTarget } from '../../../state_manager/interfaces/fundraising.ts'
import { getAccessToken } from '../../../core/auth/authService'
import { store } from '../../../state_manager/store.ts'
import type { AppDispatch } from '../../../state_manager/store.ts'

export const useFundraisingPipelineData = (defaultFundId: string | null) => {
  const dispatch = useDispatch<AppDispatch>()
  const pipelineProspectsData = useSelector(
    (state: { fundraising?: { pipeline?: { data?: unknown[] } } }) => state.fundraising?.pipeline?.data ?? []
  )
  const [pipelineProspectsLoading, setPipelineProspectsLoading] = useState(false)

  const handleFetchPipelineProspects = useCallback(async () => {
    try {
      setPipelineProspectsLoading(true)
      const currentToken = getAccessToken(store.getState().auth)

      if (!currentToken) {
        dispatch(
          setFundraising({ response: { data: [], hasMore: false, totalCount: 0 }, target: FundraisingTarget.PIPELINE })
        )
        return
      }

      const filters = defaultFundId ? [{ key: 'prospects__fund', value: [defaultFundId] }] : []

      const response = await fetchFundraisingFiltered([], filters, 1, null, currentToken, null, 'pipeline_board')

      if (response.data && Array.isArray(response.data)) {
        dispatch(
          setFundraising({
            response: { data: response.data, hasMore: response.hasMore ?? false, totalCount: response.totalCount ?? 0 },
            target: FundraisingTarget.PIPELINE
          })
        )
      } else {
        dispatch(
          setFundraising({ response: { data: [], hasMore: false, totalCount: 0 }, target: FundraisingTarget.PIPELINE })
        )
      }
    } catch (e) {
      console.error('Error fetching pipeline prospects:', e)
      dispatch(
        setFundraising({ response: { data: [], hasMore: false, totalCount: 0 }, target: FundraisingTarget.PIPELINE })
      )
    } finally {
      setPipelineProspectsLoading(false)
    }
  }, [defaultFundId, dispatch])

  useEffect(() => {
    handleFetchPipelineProspects()
  }, [defaultFundId, handleFetchPipelineProspects, dispatch])

  return {
    pipelineProspectsData:
      pipelineProspectsData as import('../../../state_manager/interfaces/fundraising.ts').ProspectRecord[],
    pipelineProspectsLoading,
    handleFetchPipelineProspects
  }
}
